import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, setDeleteProfile, setProfiles, setProfilesSearch, setSingleProfile, setUpdateProfile, startLoading } from '../reducers/profileSlice';

export const actionFetchProfiles = ({page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchProfiles({page})
        dispatch({
            type: setProfiles.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchProfilesBySearch = ({searchQuery, page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchProfilesBySearch({searchQuery, page})
        dispatch({
            type: setProfilesSearch.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchProfile = ({id}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchProfile({id})
        dispatch({
            type: setSingleProfile.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchUserProfile = ({userId}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchUserProfile({userId})
        dispatch({
            type: setSingleProfile.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionUpdateProfile = ({id, updatedProfile}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.updateProfile({id, updatedProfile})
        dispatch({
            type: setUpdateProfile.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionDeleteProfile = ({id}: api.ApiParams) => async (dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const data = await api.deleteProfile({id})
        dispatch({
            type: setDeleteProfile.type,
            payload: id
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}